<template>
    <div class="full-page" :class="{'nav-open': true}">
<!--        <b-nav md-elevation="0" class="md-transparent md-toolbar-absolute">-->
<!--            <div class="md-toolbar-row md-offset">-->
<!--                <div class="md-toolbar-section-start">-->
<!--                    <h3 class="md-title">{{$route.name}}</h3>-->
<!--                </div>-->
<!--                <div class="md-toolbar-section-end">-->


<!--                    <div class="md-collapse" :class="{'off-canvas-sidebar': responsive}">-->
<!--                        <b-list>-->
<!--                            <b-nav-item  to="/explore/map" >-->
<!--                                <md-icon>dashboard</md-icon>-->
<!--                                Explore Trips-->
<!--                            </b-nav-item >-->
<!--                            <b-nav-item to="/explore/map/my" @click="linkClick" v-if="isAuthenticated">-->
<!--                                <md-icon>map</md-icon>-->
<!--                                My Trips-->
<!--                            </b-nav-item>-->
<!--                            <b-nav-item to="/register" @click="linkClick" v-if="!isAuthenticated">-->
<!--                                <md-icon>person_add</md-icon>-->
<!--                                Register-->
<!--                            </b-nav-item>-->
<!--                            <b-nav-item to="/login" @click="linkClick" v-if="!isAuthenticated">-->
<!--                                <md-icon>fingerprint</md-icon>-->
<!--                                login-->
<!--                            </b-nav-item>-->
<!--                            <b-nav-item @click="userSignOut" v-if="isAuthenticated">-->
<!--                                <md-icon>lock_open</md-icon>-->
<!--                                lock-->
<!--                            </b-nav-item>-->
<!--                        </b-list>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </b-nav>-->
        <div class="wrapper wrapper-full-page" >
            <div class="page-header header-filter" :class="setPageClass" filter-color="black" :style="setBgImage">
                <div class="container md-offset">
                        <router-view></router-view>

<!--                    <footer class="footer">-->
<!--                        <div class="container b-offset">-->
<!--                            <nav>-->
<!--                                <ul>-->
<!--                                    <li>-->
<!--                                        <router-link :to="{path:'/dashboard'}">Home</router-link>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#">-->
<!--                                            Company-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#">-->
<!--                                            Portfolio-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#">-->
<!--                                            Blog-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </nav>-->
<!--                            <div class="copyright text-center">-->
<!--                                &copy; {{ new Date().getFullYear() }}-->
<!--                                CrazyTrip, made with-->
<!--                                <i class="fa fa-heart heart"></i> for a better web-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </footer>-->
                </div>

            </div>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    props:      {
      backgroundColor: {
        type:    String,
        default: 'black'
      }
    },
    inject:     {
      autoClose: {
        default: true
      }
    },
    data ()
    {
      return {
        responsive:             false,
        showMenu:               false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 300,
        year:                   new Date().getFullYear(),
      }
    },
    computed:   {
      isAuthenticated ()
      {
        return this.$store.getters.isAuthenticated
      },
      setBgImage ()
      {
        let images = {
          Pricing:  '/img/bg-pricing.jpg',
          Login:    '/img/login.jpg',
          Register: '/img/register.jpg',
          Lock:     '/img/lock.jpg',
          NotFound:     '/img/lock.jpg',
          Welcome:     '/img/lock.jpg',
        }
        return {
          backgroundImage: `url(${images[this.$route.name]})`
        }
      },
      setPageClass ()
      {
        return `${this.$route.name}-page`.toLowerCase()
      }
    },
    methods:    {
      userSignOut()
      {
        this.$store.dispatch('userSignOut', {})
      },

      toggleNavbar ()
      {
        document.body.classList.toggle('nav-open')
        this.showMenu = !this.showMenu
      },
      closeMenu ()
      {
        document.body.classList.remove('nav-open')
        this.showMenu = false
      },
      onResponsiveInverted ()
      {
        if (window.innerWidth < 991)
        {
          this.responsive = true
        } else
        {
          this.responsive = false
        }
      }
    },
    mounted ()
    {
      this.onResponsiveInverted()
      window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy ()
    {
      this.closeMenu()
      window.removeEventListener('resize', this.onResponsiveInverted)
    },
    beforeRouteUpdate (to, from, next)
    {
      // Close the mobile menu first then transition to next page
      if (this.showMenu)
      {
        this.closeMenu()
        setTimeout(() => {
          next()
        }, this.menuTransitionDuration)
      } else
      {
        next()
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "AuthLayout.scss";
</style>
